module.exports = __webpack_public_path__ + "static/media/salesforce-formula1-logos.4d92f26e.png";